import { withFormik } from 'formik'
/** @todo No @types for yup so have to require over import to skip TSC */
const Yup = require('yup')

import { LoginForm } from '../../../components/pages/LoginForm/LoginForm'
import { Props } from '../../../components/pages/Login/Login'

export type Values = {
  email: string;
  password: string;
}

const withFormikComp = withFormik<Props, Values, Values>({
  displayName: 'LoginForm',

  mapPropsToValues: (props) => {
    return {
      email: '',
      password: '',
    }
  },

  validationSchema: Yup.object().shape({
    email: Yup.string().email().required('Email is required'),
    password: Yup.string().required('Password is required'),
  }),

  validateOnChange: true,

  handleSubmit: (values, { props: { login, history } }) => {
    login(values, history)
  },
})

export default withFormikComp(LoginForm)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/LoginForm/LoginForm.tsx